/* J·SKIN LAB — zapis do newslettera z tematami troski i zgodą na WhatsApp (NL1, 25.09.2026). Formularz: snippets/jsl-zapis-form.liquid.
   Przy wysyłce skleja contact[tags]: tagi bazowe + zaint-<grupa> z zaznaczonych tematów; przy zgodzie WhatsApp: zgoda-whatsapp,
   zgoda-wa-v1, zgoda-wa-<rrrr-mm-dd> i numer w contact[note]; w doborze: dobor-rutyna, zaint-<grupa> z odpowiedzi
   i tag „rutyna|…” z parametrami linku rutyny (PRAW1 25.09: bez informacji o zdrowiu — parametr u nie trafia do tagów). Niczego nie zapisuje poza formularzem; sessionStorage pamięta tylko,
   czy pokazać po zapisie przycisk „Potwierdź numer na WhatsApp” (bez numeru i adresu). */
(function () {
  'use strict';
  var KL = 'jsl-zapis-wa';
  // dobór: kod problemu z /pages/dobor (?p=) → grupa troski (NL1 grupy.json)
  var PROB = { p: 'przebarwienia', z: 'zmarszczki', t: 'tradzik', n: 'naczynka', o: 'bariera', j: 'zmarszczki', r: 'pory', b: 'bariera', c: 'oczy', l: 'tradzik' };
  var STREFA = { wlosy: 'wlosy', cialo: 'cialo', stopy: 'cialo' };
  function dzis() { var d = new Date(), z = function (n) { return (n < 10 ? '0' : '') + n; }; return d.getFullYear() + '-' + z(d.getMonth() + 1) + '-' + z(d.getDate()); }
  function tel(s) {
    var n = String(s || '').replace(/[\s().\/-]/g, '');
    if (/^00/.test(n)) n = '+' + n.slice(2);
    if (/^\d{9}$/.test(n) && /^pl/i.test(document.documentElement.lang || '')) n = '+48' + n; // 9 cyfr bez kierunkowego = numer polski tylko na PL
    if (/^\d{10,15}$/.test(n)) n = '+' + n;
    return /^\+\d{10,15}$/.test(n) ? n : '';
  }
  // PRAW2 (25.09): odpowiedzi o skórze mogące ujawniać stan zdrowia (cera a; problemy t, l, n) nie trafiają do tagów ani do linku rutyny (jak w jsl10s-dobor.js)
  var ZDR_C = { a: 1 }, ZDR_P = { t: 1, l: 1, n: 1 };
  function zDoboru(tagi) {
    var q = new URLSearchParams(location.search), s = q.get('s') || 'twarz', p = q.get('p') || '';
    if (ZDR_P[p]) p = '';
    tagi.push('dobor-rutyna');
    if (STREFA[s]) tagi.push('zaint-' + STREFA[s]);
    else if (p === 'l' && s === 'wlosy') tagi.push('zaint-wlosy');
    else if (PROB[p]) tagi.push('zaint-' + PROB[p]);
    // PRAW1 (25.09): informacje o zdrowiu z doboru (u: ciąża, retinoidy, zabieg, alergia) nie trafiają do tagów marketingowych (art. 9 RODO)
    // link rutyny jako jeden tag (Shopify: tag ≤ 255 znaków, bez przecinków) — mail odtwarza z niego /pages/dobor?…
    var r = ['rutyna'];
    ['s', 'c', 'p', 'z', 'w'].forEach(function (k) { var v = q.get(k); if (k === 'p') v = p; if (k === 'c' && v && ZDR_C[v.toLowerCase()]) v = ''; if (v) r.push(k + ':' + v.replace(/,/g, '.')); });
    var t = r.join('|');
    if (r.length > 1 && t.length <= 255) tagi.push(t);
  }
  function podepnij(f) {
    if (f.dataset.jzOk) return; f.dataset.jzOk = '1';
    var tagiIn = f.querySelector('[data-jz-tagi]'), nota = f.querySelector('[data-jz-nota]');
    var wa = f.querySelector('[data-jz-wa]'), telBox = f.querySelector('[data-jz-tel-box]'), telIn = f.querySelector('[data-jz-tel]');
    var telBlad = f.querySelector('[data-jz-tel-blad]'), email = f.querySelector('input[type="email"]'), emBlad = f.querySelector('[data-jz-blad-email]');
    var baza = tagiIn ? tagiIn.value : '';
    if (wa && telBox) wa.addEventListener('change', function () {
      telBox.hidden = !wa.checked; if (telIn) telIn.required = wa.checked;
      if (wa.checked && telIn) telIn.focus(); else if (telBlad) telBlad.hidden = true;
    });
    f.addEventListener('submit', function (e) {
      if (email && emBlad) {
        var okE = email.checkValidity(); emBlad.hidden = okE; email.setAttribute('aria-invalid', okE ? 'false' : 'true');
        if (!okE) { e.preventDefault(); email.focus(); return; }
      }
      var tagi = baza.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      f.querySelectorAll('[data-jz-temat]:checked').forEach(function (c) { tagi.push('zaint-' + c.value); });
      if (f.classList.contains('jz--dobor')) zDoboru(tagi);
      var chceWa = false;
      if (wa && wa.checked) {
        var n = tel(telIn && telIn.value);
        if (!n) { e.preventDefault(); if (telBlad) telBlad.hidden = false; if (telIn) { telIn.setAttribute('aria-invalid', 'true'); telIn.focus(); } return; }
        chceWa = true;
        tagi.push('zgoda-whatsapp', 'zgoda-wa-v1', 'zgoda-wa-' + dzis());
        if (nota) { nota.disabled = false; nota.value = 'WhatsApp: ' + n + ' · zgoda ' + dzis() + ' · ' + (f.className.match(/jz--(\w+)/) || [0, ''])[1] + ' · v1'; }
      }
      var widziane = {};
      if (tagiIn) tagiIn.value = tagi.filter(function (t) { if (widziane[t]) return false; widziane[t] = 1; return true; }).join(', ');
      try { if (chceWa) sessionStorage.setItem(KL, '1'); else sessionStorage.removeItem(KL); } catch (e2) { /* tryb prywatny */ }
    });
  }
  function start() {
    document.querySelectorAll('form.jz').forEach(podepnij);
    var chce = false; try { chce = sessionStorage.getItem(KL) === '1'; } catch (e) { /* tryb prywatny */ }
    if (chce) document.querySelectorAll('[data-jz-wa-potw]').forEach(function (a) { a.hidden = false; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
